var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.729 18.664c0 6.467-5.261 11.729-11.729 11.729s-11.729-5.261-11.729-11.729c0-6.452 5.237-11.703 11.684-11.728v5.333l10.129-5.865-10.129-5.864v5.33c-7.047 0.024-12.751 5.741-12.751 12.794 0 7.065 5.727 12.795 12.795 12.795 7.066 0 12.795-5.73 12.795-12.795h-1.066zM17.022 2.39l6.935 4.015-6.935 4.016v-8.030z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.82b30175d8d876e596a6b368fa87a7cd.svg";
export { ForwardRef as ReactComponent };